import { render, staticRenderFns } from "./Anim.vue?vue&type=template&id=6efe7a87&scoped=true"
import script from "./Anim.vue?vue&type=script&lang=js"
export * from "./Anim.vue?vue&type=script&lang=js"
import style0 from "./Anim.vue?vue&type=style&index=0&id=6efe7a87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe7a87",
  null
  
)

export default component.exports